<div class="mx-4 sm:mx-8 md:mx-16 lg:mx-[200px] bg-[--lightBlue] p-6 sm:p-10 rounded-lg my-5">
  <h6 class="text-[#4D748D] pb-5">
      Simulados
  </h6>
  <ul class="flex flex-col sm:flex-row gap-6 sm:gap-10" id="tools">
      <li routerLink="exams-view" class="flex items-center gap-2 cursor-pointer">
        <i class='bx bx-book-reader text-2xl'></i>
          <span>Simulados</span>
      </li>
      <li routerLink="results-view" class="flex items-center gap-2 cursor-pointer">
        <i class='bx bx-history text-2xl'></i>
          <span>Histórico Exames</span>
      </li>
      <li routerLink="questions-view" class="flex items-center gap-2 cursor-pointer">
        <i class='bx bx-book-bookmark text-2xl'></i>
          <span>Questões</span>
      </li>
  </ul>
</div>

<router-outlet></router-outlet>
